export default defineNuxtRouteMiddleware((to) => {
  const path = to.path
  const query = new URLSearchParams(
    to.query as Record<string, string>
  ).toString()

  if (path === '/') return

  if (path.endsWith('/')) {
    const newPath = path.slice(0, -1)
    const finalPath = query ? `${newPath}?${query}` : newPath

    return navigateTo(finalPath, { redirectCode: 301 })
  }
})
